import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=70a1a718&"
import script from "./CheckoutFooter.vue?vue&type=script&lang=ts&"
export * from "./CheckoutFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports